function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.8061 37.634L3.24003 45.2C3.17923 45.0178 3.15052 44.8264 3.15518 44.6343L3.15518 39.628C3.15675 39.0996 3.36734 38.5933 3.74096 38.2197C4.11457 37.8461 4.62085 37.6355 5.14922 37.634H10.8061Z",
  fill: "#f3ad61"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.4699 37.6269L7.46841 46.6283L5.1491 46.6283C4.99449 46.6297 4.84026 46.613 4.68948 46.5788L13.6415 37.6269H16.4699Z",
  fill: "#f3ad61"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.8515 46.303L22.1691 45.6595L22.1691 49.6476C22.1683 49.9118 22.063 50.165 21.8762 50.3518C21.6894 50.5386 21.4362 50.6439 21.1721 50.6446C21.0398 50.646 20.9085 50.621 20.7859 50.5713C20.6633 50.5215 20.5518 50.4479 20.4579 50.3547C20.3647 50.2608 20.2911 50.1493 20.2413 50.0267C20.1916 49.9041 20.1666 49.7729 20.168 49.6406L20.175 46.6495L10.2755 46.6495L19.2982 37.6268L20.1538 37.6339L20.1538 34.6358C20.1529 34.3704 20.2574 34.1155 20.4444 33.9272C20.6314 33.7389 20.8855 33.6326 21.1508 33.6317C21.4162 33.6307 21.6711 33.7352 21.8594 33.9222C22.0477 34.1092 22.154 34.3633 22.1549 34.6287L22.1337 37.6197L79.8548 38.3056C80.119 38.3064 80.3722 38.4117 80.559 38.5985C80.7458 38.7853 80.8511 39.0385 80.8519 39.3027C80.8519 40.222 80.6709 41.1323 80.3191 41.9816C79.9673 42.831 79.4517 43.6027 78.8016 44.2528C78.1516 44.9028 77.3798 45.4185 76.5305 45.7702C75.6811 46.122 74.7708 46.3031 73.8515 46.303Z",
  fill: "#f3ad61"
});

var SvgNinjaSwordRight = function SvgNinjaSwordRight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNinjaSwordRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ninja-sword-right.4b40eb12.svg";
export { ForwardRef as ReactComponent };